<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">All Leads</div>
        <div class="box-mini">
          <full-calendar :events="dataCalendar" @eventClick="eventCalendar" locale="en"></full-calendar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fullCalendar from 'vue-fullcalendar'
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'myCalendar',
  components: {
    'full-calendar': fullCalendar
  },
  data: function () {
    return {
      items: [],
      itemsNew: [],
      dataCalendar: []
    }
  },
  methods: {
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'danger' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    eventCalendar (event, jsEvent, pos) {
      //  console.log('eventClick', event.leadId)
      this.$router.push('/leads/detail?id=' + event.leadId)
    },
    fetchData() {
      // Object.keys(this.items).forEach(keyName => {
      //   data.append(keyName, this.items[keyName])
      // })
      axios.get('crm/v1/leads_activities?sales_id=' + Auth.Session.get().paradigm_id).then(response => {
        this.items = response.data.data.rows
        let obj = {}
        let newArray = []
        for(var i = 0; i < response.data.data.rows.length; i++) {
          var fullName = ''
          if (!(response.data.data.rows[i].lead === null)) {
            fullName = response.data.data.rows[i].lead.first_name + ' ' + response.data.data.rows[i].lead.last_name
          } else {
            fullName = 'null'
          }
          obj = {"title": response.data.data.rows[i].leads_activities_type.name + ' (' + fullName + ')', "start": moment(new Date(response.data.data.rows[i].due_date)).format('YYYY-MM-DD').toString(), "leadId": response.data.data.rows[i].leads_id}
          newArray.push(obj)
        }
        this.dataCalendar = this.dataCalendar.concat(newArray)
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="scss">
  .box-mini {
    .full-calendar-body {
      .dates {
        .dates-events {
          .events-week {
            .events-day {
              .event-box {
                .event-item {
                  background-color: #FAAD1A;
                  padding: 2px 6px;
                  color: #fff;
                }
                .event-item.is-start {
                  margin-left: 0px;
                }
              }
            }
          }
        }
        .week-row {
          .day-cell.today {
            background-color: rgba(0, 0, 0, .6);
            .day-number {
              color: #fff;
            }
          }
        }
      }
    }
  }
</style>
